import { useContext, useEffect, memo } from 'react';
import { faPlus, faMinus } from '@fortawesome/pro-regular-svg-icons';
import { ZoomContext } from 'Guide/Schematics/Diagram/Providers/d3Zoomable';
import { KeypressContext } from '../Providers/keypressContext';
import { IconButton, IconButtonProps, ButtonGroup, ButtonGroupProps, Show } from '@chakra-ui/react';
import { FaIcon } from '@ifixit/icons';

const ZOOMSTEP = 0.25;

function ToolButton({ ...props }: IconButtonProps) {
   return (
      <IconButton
         variant="outline"
         colorScheme="gray"
         background="white"
         height="40px"
         width="40px"
         {...props}
      />
   );
}

function ZoomButtonGroup(props: ButtonGroupProps) {
   return (
      <ButtonGroup
         boxShadow="2xl"
         borderRadius="md"
         position="fixed"
         zIndex="9999"
         isAttached={true}
         {...props}
      />
   );
}

const registerShortCuts = (zoomIn: () => void, zoomOut: () => void) => {
   // eslint-disable-next-line react-hooks/rules-of-hooks -- FIXME: React Hook "useContext" is called in "registerShortCuts" that is neither a React function component nor a custom Hook ...
   const keypressContext = useContext(KeypressContext);
   // eslint-disable-next-line react-hooks/rules-of-hooks -- FIXME: React Hook "useContext" is called in "registerShortCuts" that is neither a React function component nor a custom Hook ...
   const zoomContext = useContext(ZoomContext);
   // eslint-disable-next-line react-hooks/rules-of-hooks -- FIXME: React Hook "useEffect" is called in "registerShortCuts" that is neither a React function component nor a custom Hook ...
   useEffect(() => {
      const mappings = [
         { id: 'Zoom', key: '+', action: zoomIn, overlayText: '+' },
         { id: 'Zoom', key: '=', action: zoomIn, overlayText: '+' },
         { id: 'Zoom', key: '-', action: zoomOut, overlayText: '-' },
         { id: 'Zoom', key: '_', action: zoomOut, overlayText: '-' },
      ];

      keypressContext.pushMappings(mappings);

      return () => {
         keypressContext.popMappings(mappings);
      };
   }, [zoomContext]);
};

const Tools = memo(function ToolsInternal() {
   const zoomContext = useContext(ZoomContext);
   const zoomIn = () => zoomContext.zoomBy(1 + ZOOMSTEP);
   const zoomOut = () => zoomContext.zoomBy(1 - ZOOMSTEP);

   registerShortCuts(zoomIn, zoomOut);

   return (
      <Show above="md">
         <ZoomButtonGroup orientation="vertical" marginTop="110px" marginLeft="32px">
            <ToolButton
               onClick={zoomIn}
               icon={<FaIcon icon={faPlus} fontSize="16px" />}
               aria-label="Zoom In Diagram Viewer"
            />
            <ToolButton
               onClick={zoomOut}
               icon={<FaIcon icon={faMinus} fontSize="16px" />}
               aria-label="Zoom Out Diagram Viewer"
            />
         </ZoomButtonGroup>
      </Show>
   );
});

export default Tools;
